import { useDispatch, useSelector } from "react-redux";
import type { TypedUseSelectorHook } from "react-redux";
import type { RootState, AppDispatch } from "./store";

export { store } from "./store";
export type { AppDispatch, RootState } from "./store";

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Client slices
export {
  setApplication,
  setVerificationStatus,
  selectVerificationState,
  selectApplication,
  setIsVerificationStatusLoading,
  applicationSlice,
  verificationStatusSlice,
} from "./slices/client";

// API slices
export {
  extendedApiSlice,
  useGetProgramEventListQuery,
  selectProgram,
  selectRefData,
  useGetEligibleEvacuationCoordinatesQuery,
  useGetAllProgramsQuery,
  useLazyClearSessionQuery,
  useCreateGenerationSessionMutation,
  useGenerateGenerationJWTMutation,
  useGetSessionQuery,
} from "./slices/api";
